function getImage(image_id) {
  return `${import.meta.env.VITE_API_URL}/images/${image_id}`;
}

async function getFileFromURL(url, filename, mimeType) {
  // Fetch the image
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-store', // IMPORTANT: prevents Chrome's caching issues with CORS
  });

  // Convert the response to a Blob
  const blob = await response.blob();

  // Convert the Blob to a File
  const file = new File([blob], filename, { type: mimeType });
  
  return file;
}

function randomize(attr, length) {
  const charCode = attr.charCodeAt(0);
  const quotient = Math.floor(charCode / length);
  const index = charCode - quotient * length;

  return index;
}

function getRandomUserPicture(attr) {
  const pictures = ["lemon-green.png", "lemon-yellow.png", "lemon-orange.png"];

  return `/images/defaults/user/${pictures[randomize(attr, pictures.length)]}`;
}

function getRandomSpacePicture(attr) {
  const pictures = ["lemon-green.svg", "lemon-yellow.svg", "lemon-purple.svg"];

  return `/images/defaults/space/${pictures[randomize(attr, pictures.length)]}`;
}

function getRandomCampaignPicture(attr) {
  const pictures = [
    "lemon.png",
    "look.png",
    "search.png",
    "seat.png",
    "talk.png",
  ];

  return `/images/defaults/campaign/${
    pictures[randomize(attr, pictures.length)]
  }`;
}

export {
  getImage,
  getFileFromURL,
  getRandomUserPicture,
  getRandomSpacePicture,
  getRandomCampaignPicture,
};
